var selectedProducts = [];
var tab = getUrlParameter('tab');
console.log(tab);
if(tab != false) {
  $(".customerDeskNavItem, .customerDeckTabContent").removeClass("selected");
  $(".customerDeskNavItem[data-index='"+tab+"'], .customerDeckTabContent[data-index='"+tab+"']").addClass("selected");
}
$(".customerDeskNavItem").on("click", function(e) {
  e.preventDefault();
  let thisIndex = $(this).attr("data-index");
  $(".customerDeckTabContent, .customerDeskNavItem").removeClass("selected");
  $(".customerDeckTabContent[data-index='"+thisIndex+"']").addClass("selected");
  $(this).addClass("selected");
})
$(".deckCardAdd, .deckCardAdded").on("click", function(e){
  e.preventDefault();
  let thisCard = $(this).closest(".product-card, .allWineRecommendationLine");
  let thisProductId = thisCard.attr("data-product-id");
  $(".product-card[data-product-id='"+thisProductId+"'], .allWineRecommendationLine[data-product-id='"+thisProductId+"']").toggleClass("selected");
  updateProducts();
});
$(".bottomButton2").on("click", function(e){
  e.preventDefault();
  if($(this).hasClass("enable")) {
    let totalPrice = 0;
    selectedProducts.forEach(function(item){
      totalPrice += item.price;
    });
    $(".bottomButton4 span").text(" - "+formatMoneyDeck(totalPrice, moneyFormarDeck));
    $(".step2Wrapper").hide();
    $(".step3Wrapper").css("display", "flex");
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".step3Wrapper").offset().top - 180
    }, 1000);
  }
});
$(".wineAndPrefferenceLink").on("click", function(e){
  e.preventDefault();
});
$(".bottomButton1").on("click", function(e){
  e.preventDefault();
});
$(".bottomButton3").on("click", function(e){
  e.preventDefault();
  $(".step2Wrapper").show();
  $(".step3Wrapper").hide();
});
$(".bottomButton4").on("click", async function(e){
  e.preventDefault();
  updateQty();
  if(selectedProducts.length > 0) {
    await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    });
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    let formData = {
     'items': selectedProducts.map(item => {
       return {
         'id': item.variant_id,
         'quantity': item.quantity
       }
     }),
      'sections': sectionsToBundle.join(",")
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(async function(responseJson) {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent1 = await fetch(`${Shopify.routes.root}cart.js`);
      const cartContent = await cartContent1.json();
      cartContent["sections"] = responseJson["sections"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          onSuccessDo: "force_open_drawer",
          cart: cartContent
        }
      }));
      selectedProducts = [];
      updateSelectedProducts();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
});

function updateQty() {
  selectedProducts.forEach(function(elem, index){
    let newQty = Number($(".step3Product[data-product-id='"+elem.id+"']").find(".quantity-selector__input").val());
    selectedProducts[index].quantity = newQty;
  });
}

function updateProducts() {
  selectedProducts = [];
  $(".product-card").each(function(){
    if($(this).hasClass("selected")) {
      let productId = Number($(this).attr("data-product-id"));
      let that = this;
      recommendProducts.forEach(function(elem){
        if(elem.id == productId) {
          selectedProducts.push(elem);
        }
      });
    }
  });
  if(selectedProducts.length > 0) {
    $(".bottomButton2").addClass("enable");
    $(".step3Products").empty();
    selectedProducts.forEach(function(elem){
      let productElem = `<div class="step3Product" data-product-id="${elem.id}">
      <div class="step3ProductImageWrapper">
            <img src="${elem.image}" alt="${elem.title}" srcset="${elem.image} 220w" width="220" height="220" class="step3ProductImage">
            </div>
            <div class="step3ProductContent">
            <div class="step3ProductContent1">
              <div class="step3ProductContentTitle">${elem.title}</div>
              <div class="step3ProductContentPrice">${formatMoneyDeck(elem.price, moneyFormarDeck)}<span class="productCardDeckSizeSplit">|</span><span class="productCardDeckSize">${elem.size}</span></div>
                </div>
              <div class="step3ProductContentQty ${elem.quantity == 1 ? 'showDelete' : ''}">
                <quantity-selector class="quantity-selector ">
                  <button class="quantity-selector__button">
                    <span class="sr-only">Decrease quantity</span>
                    <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
                      <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                    </svg>
                  </button>
  
                  <quantity-input style="--quantity-selector-character-count: 1ch;">
                    <input min="1" max="${elem.inventory_quantity}" class="quantity-selector__input " type="number" value="${elem.quantity}" name="quantity" form="product-form-main-10111037243665-template--23922490573073__main" inputmode="numeric" aria-label="Change quantity">
                  </quantity-input>
  
                  <button class="quantity-selector__button">
                    <span class="sr-only">Decrease quantity</span>
                    <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
                      <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                    </svg>
                  </button>
                </quantity-selector>
                <div class="step3ProductContentQtyRemove">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M13.4238 16.5689H4.27637L4.27637 5.20862H13.4238V16.5689Z" stroke="#151816" stroke-width="1.8" stroke-miterlimit="10"></path>
                    <path d="M2.09375 5.20862L4.27668 5.20862" stroke="#151816" stroke-width="1.8" stroke-miterlimit="10"></path>
                    <path d="M13.4238 5.20862L15.6038 5.20862" stroke="#151816" stroke-width="1.8" stroke-miterlimit="10"></path>
                    <path d="M7.50391 7.91003V13.8678" stroke="#151816" stroke-width="1.6" stroke-miterlimit="10"></path>
                    <path d="M10.1953 7.90991V13.8677" stroke="#151816" stroke-width="1.6" stroke-miterlimit="10"></path>
                    <path d="M7.03906 2.40137H10.6602" stroke="#151816" stroke-width="1.8" stroke-miterlimit="10"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>`;
      $(".step3Products").append(productElem);
    });
  } else {
    $(".bottomButton2").removeClass("enable");
  }
  $(".quantity-selector__input").off("change").on("change", function(){
    if($(this).val() == 1) {
      $(this).closest(".step3ProductContentQty").addClass("showDelete");
    } else {
      $(this).closest(".step3ProductContentQty").removeClass("showDelete");
    }
    updateTotalPrice();
  });
  $(".step3ProductContentQtyRemove").off("click").on("click", function(){
    let product_id = Number($(this).closest(".step3Product").attr("data-product-id"));
    $(".product-card").each(function(){
      if($(this).hasClass("selected")) {
        let productId = Number($(this).attr("data-product-id"));
        let that = this;
        if(product_id == productId) {
          $(that).removeClass("selected");
        }
      }
    });
    updateProducts();
    if(selectedProducts.length == 0) {
      $(".step2Wrapper").show();
      $(".step3Wrapper").hide();
      $([document.documentElement, document.body]).animate({
          scrollTop: $(".wineRecommendationWrapper").offset().top - 100
      }, 1000);
    }
    updateTotalPrice();
  });
}

function updateTotalPrice() {
  updateQty();
  let totalPrice = 0;
  selectedProducts.forEach(function(item){
    totalPrice += item.price*item.quantity;
  });
  $(".bottomButton4 span").text(" - "+formatMoneyDeck(totalPrice, moneyFormarDeck));
}

function formatMoneyDeck(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};